<script>
  import { mapGetters,mapState } from 'vuex'

  export default {
    data () {
      return {
        user: {},
        socketStyle: {
          backgroundColor: ''
        },
      }
    },
    watch: {
      socketStatus (newVale) {
        let socketStatus = -1
        socketStatus = newVale
        this.setSocketStyle(newVale)
      }
    },
    computed: {
      socketStatus () {
        if (this.$store.getters.socketStatus == null) {
          this.setSocketStyle(-1)
          return -1
        } else {
          this.setSocketStyle(this.$store.getters.socketStatus)
          return this.$store.getters.socketStatus
        }
      }
    },
    mounted () {
    },
    methods: {
      onKeyup (e) {
        this.$store.dispatch('search', e.target.value)
      },
      setSocketStyle(socketStatus){
        switch (socketStatus) {
          case 0:
            this.socketStyle.backgroundColor = 'rgb(255,190,48)'
            break
          case 1:
            this.socketStyle.backgroundColor = 'rgb(41,206,67)'
            break
          default:
            this.socketStyle.backgroundColor = 'rgb(230,75,66)'
            break
        }
      }
    },
    created () {
      this.user = this.$store.getters['user']
    },

  }
</script>

<template>
  <div class="card">
    <header>
      <img class="avatar" width="40" height="40" :alt="user.name" :src="user.img">
      <p class="name">{{user.name}}
        <span class="status-point" v-model="socketStatus" v-bind:style="[socketStyle]"></span>
      </p>
    </header>
    <footer>
      <input class="search" type="text" placeholder="请输入角色名" @keyup="onKeyup">
    </footer>
  </div>
</template>

<style scoped lang="less">
  .card {
    padding: 12px;
    border-bottom: solid 1px #24272C;

    footer {
      margin-top: 10px;
    }

    .avatar, .name {
      vertical-align: middle;
    }

    .avatar {
      border-radius: 2px;
    }

    .name {
      display: inline-block;
      margin: 0 0 0 15px;
      font-size: 16px;
    }

    .search {
      padding: 0 10px;
      width: 100%;
      font-size: 12px;
      color: #fff;
      height: 30px;
      line-height: 30px;
      border: solid 1px #3a3a3a;
      border-radius: 4px;
      outline: none;
      background-color: #26292E;
    }

    .status-point {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;

    }
  }
</style>
